<template>
  <div
    :class="[
      'droopy',
      status !== undefined && (status ? 'droopy-ok' : 'droopy-error'),
    ]"
  >
    <div class="timer-bar" :style="`width:${remainingTimePercent}%;`"></div>
    <div class="game-overlay" v-if="remainingTimePercent == 0">
      <button class="other-session pretty-button" @click="anotherSession">
        Spila aftur
      </button>
    </div>
    <div class="sidebar">
      <dropdown
        :close-on-click="false"
        :is-icon="false"
        :class-name="'droopy-dropdown'"
      >
        <template slot="body">
          <preferences></preferences>
        </template>
      </dropdown>
      <ul class="categories">
        <li
          v-for="entry in selectedCategories"
          :key="'selected-' + entry.category"
          class="selected li-category-top"
        >
          <span class="category" @click="onCategorySelected(entry)">{{
            entry.category
          }}</span>
        </li>
        <li
          v-for="entry in categories"
          :key="entry.category"
          :class="['li-category', entry.selected && 'selected']"
        >
          <span class="category" @click="onCategorySelected(entry)">{{
            entry.category
          }}</span>
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="content-header">
        <div class="content-header-group">
          <div class="record-actions">
            <button
              class="record-action record-start"
              :disabled="recordMode === 'recording'"
              @click="onRecord()"
            ></button>
            <!-- button
              class="record-action record-pause"
              :disabled="recordMode !== 'recording'"
              @click="onPauseRecording()"
            ></button -->
            <button
              class="record-action record-stop"
              :disabled="recordMode !== 'recording'"
              @click="onStopRecording()"
            ></button>
            <button
              class="record-action record-play"
              :disabled="recordUrl === undefined"
              @click="onPlayRecord()"
            ></button>
            <audio
              ref="player"
              v-if="recordUrl"
              :src="recordUrl"
              autoplay
            ></audio>
          </div>
        </div>
        <div class="content-header-group">
          <button class="other-game pretty-button" @click="anotherGame">
            nýr leikur
          </button>
          <span>{{ gameSuccess }}/{{ gameCount }}</span>
        </div>
        <div class="content-header-group">
          <div class="search-input">
            <input
              type="text"
              id="leita"
              name="leita"
              placeholder="Leita"
              v-model="search"
            />
            <div
              v-if="searchResult.length > 0"
              class="icon-close"
              @click="onCloseSearch"
            ></div>
          </div>
          <div v-if="searchResult.length > 0" class="search-result">
            <div class="icon-close" @click="onCloseSearch"></div>
            <ul>
              <li
                v-for="(word, index) in searchResult"
                :key="`search-${index}`"
              >
                <span
                  class="search-src"
                  v-html="highlightSearch(word.src)"
                ></span
                ><span
                  class="search-target"
                  v-html="highlightSearch(word.target)"
                >
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- https://stackoverflow.com/questions/43658481/passing-props-dynamically-to-dynamic-component-in-vuejs -->
      <!-- for adding properties: v-bind="gameProperties" -->
      <component
        ref="game"
        :is="gameComponent"
        v-on:gameStatus="onGameStatus"
        :class="remainingTimePercent == 0 && 'game-disabled'"
      ></component>
      <div class="game-status" @click="onClickStatus"></div>
      <Timer
        class="droopy-timer"
        ref="timer"
        :deadline="settings.duration * 60"
        :speed="1000"
        v-on:remaining-time="remainingTime"
      />
    </div>
    <div
      v-if="showFrame"
      class="icon-close close-frame"
      @click="onCloseFrame"
    ></div>
    <vue-friendly-iframe
      v-show="showFrame"
      ref="iframe"
      :src="iframeUrl"
      frameborder="0"
      gesture="media"
      allow="encrypted-media"
      sandbox="allow-same-origin allow-scripts"
      @load="onLoad"
      @iframe-load="onIframeLoad"
    ></vue-friendly-iframe>
  </div>
</template>

<script>
const gameSettings = require("@/gameSettings.js");
import vocabularyService from "@/services/vocabulary.js";
import { mapGetters } from "vuex";
import GameSrcToTarget from "@/components/GameSrcToTarget.vue";
import GameOneToMany from "@/components/GameOneToMany.vue";
import GamePath from "@/components/GamePath.vue";
import GameSpell from "@/components/GameSpell.vue";
import GameSyllables from "@/components/GameSyllables.vue";
import GameHole from "@/components/GameHole.vue";
import Preferences from "@/components/Preferences.vue";
import Timer from "@/components/Timer.vue";
// import VueFriendlyIframe from 'vue-friendly-iframe';
import VGauge from "vgauge";
import Dropdown from "bp-vuejs-dropdown";
import router from "../router";
//import Recorder from "@/assets/js/recorder.js"; // undefined Recorder in npm run build mode => works when included from script tag in index.html

let URL = window.URL || window.webkitURL;
let gumStream;
//stream from getUserMedia()
let rec;
//Recorder.js object
let input;
//MediaStreamAudioSourceNode we'll be recording
// shim for AudioContext when it's not avb.
let AudioContext = window.AudioContext || window.webkitAudioContext;
let audioContext; /*= new AudioContext;*/

// function createDownloadLink(blob) {
//   var url = URL.createObjectURL(blob);
//   var au = document.createElement('audio');
//   var li = document.createElement('li');
//   var link = document.createElement('a');
//   //add controls to the <audio> element
//   au.controls = true;
//   au.src = url;
//   //link the a element to the blob
//   link.href = url;
//   link.download = new Date().toISOString() + '.wav';
//   link.innerHTML = link.download;
//   //add the new audio and a elements to the li element
//   li.appendChild(au);
//   li.appendChild(link);
//   //add the li element to the ordered list
//   recordingsList.appendChild(li);
// }

export default {
  name: "Droopy",
  components: {
    GameSrcToTarget,
    GameOneToMany,
    GamePath,
    GameSpell,
    GameSyllables,
    GameHole,
    Preferences,
    Timer,
    // VueFriendlyIframe,
    VGauge,
    Dropdown,
  },
  data() {
    return {
      searchTimeout: null,
      search: "",
      searchResult: [],
      status: undefined,
      showFrame: false,
      arnastofnunUrl: "",
      timeout: undefined,
      recordMode: "none",
      recordUrl: undefined,
      remainingTimePercent: 100,
      settings: gameSettings.get(),
    };
  },
  watch: {
    search: function (val, oldVal) {
      this.search = val;
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.searchTimeout = setTimeout(() => {
        this.searchResult = vocabularyService.search({ search: this.search });
        console.log(this.searchResult);
      }, 500);
    },
  },
  computed: {
    ...mapGetters([
      "gameCount",
      "gameSuccess",
      "categories",
      "selectedCategories",
      "game",
    ]),
    gameComponent() {
      return this.$store.getters.game.component;
    },
    gameProperties() {
      return this.$store.getters.game.props;
    },
    iframeUrl() {
      return this.arnastofnunUrl || "about:blank";
    },
  },
  mounted() {
    // this.anotherGame();
  },
  created() {
    let droopy = this;
    let vm = router.app;
    vm.$on("bin.arnastofnun", (url) => {
      console.log(url);
      // this.$refs.child.set('foo', 'new value')
      // droopy.$refs.iframe.src = url;
      droopy.arnastofnunUrl = url;
    });
  },
  methods: {
    anotherSession() {
      this.$refs.timer.reset();
      this.anotherGame();
    },
    anotherGame() {
      this.recordUrl = undefined;
      this.$store.dispatch("newGame");
    },
    onCategorySelected(entry) {
      if (entry) {
        entry.selected = !entry.selected;
      }
      this.$store.dispatch("categorySelected", entry);
    },
    onCloseSearch(e) {
      this.search = "";
    },
    highlightSearch(word) {
      let re = new RegExp(`(${this.search})`, "g");
      return word.replace(re, "<span class='search-match'>$1</span>");
    },
    onGameStatus(status) {
      this.status = status;
      // console.log("droopy status" + status);
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
      if (status) {
        this.$store.dispatch("incrementSuccess");
        this.$store.dispatch("failedWord", undefined);
        this.timeout = setTimeout(() => {
          this.anotherGame();
        }, 3000);
      } else if (status === false) {
        this.$store.dispatch("incrementFailure");
        this.$refs.game.solution();
        this.timeout = setTimeout(() => {
          this.anotherGame();
        }, 3000);
      }
    },
    remainingTime(val) {
      if (val > 0) {
        let pct = (100 * val) / (this.settings.duration * 60000);
        pct = Math.round(pct * 100) / 100;
        this.remainingTimePercent = pct;
      } else {
        this.remainingTimePercent = 0;
        // this.anotherGame();
        if (!this.status) {
          this.$refs.game.solution();
        }
      }
    },
    onClickStatus() {
      if (this.status !== undefined) {
        this.$refs.timer.stop();
      }
    },
    onLoad() {
      console.log("iframe onLoad");
      this.showFrame = this.iframeUrl.startsWith("http");
    },
    onIframeLoad() {
      console.log("iframe onIframeLoad");
    },
    onCloseFrame(e) {
      this.arnastofnunUrl = "";
    },
    gaugeOpts() {
      // http://bernii.github.io/gauge.js/
      return {
        angle: 0, // The span of the gauge arc
        lineWidth: 0.2, // The line thickness
        radiusScale: 0.5, // Relative radius
        pointer: {
          length: 0, // // Relative to gauge radius
          strokeWidth: 0, // The thickness
          color: "#000000", // Fill color
        },
        limitMax: false, // If false, max value increases automatically if value > maxValue
        limitMin: false, // If true, the min value of the gauge will be fixed
        colorStart: "#8b8b8c", // Colors
        colorStop: "#233a54", // just experiment with them
        strokeColor: "#d0d0d0", // to see which ones work best for you
        generateGradient: true,
        highDpiSupport: true, // High resolution support
      };
      // return {
      //   angle: 0.35, // The span of the gauge arc
      //   lineWidth: 0.1, // The line thickness
      //   radiusScale: 1, // Relative radius
      //   pointer: {
      //     length: 0.6, // // Relative to gauge radius
      //     strokeWidth: 0.035, // The thickness
      //     color: "#000000", // Fill color
      //   },
      //   limitMax: false, // If false, max value increases automatically if value > maxValue
      //   limitMin: false, // If true, the min value of the gauge will be fixed
      //   colorStart: "#277e75", // Colors
      //   colorStop: "#274459", // just experiment with them
      //   strokeColor: "#b3ffea", // to see which ones work best for you
      //   generateGradient: true,
      //   highDpiSupport: true, // High resolution support
      // };
    },
    onRecord() {
      if (!audioContext) {
        audioContext = new AudioContext();
      }

      console.log("start recording");

      /* Simple constraints object, for more advanced audio features see https://addpipe.com/blog/audio-constraints-getusermedia/ */

      let constraints = {
        audio: true,
        video: false,
      };
      /* Disable the record button until we get a success or fail from getUserMedia() */

      this.recordUrl = undefined;
      this.recordMode = "recording";

      /* We're using the standard promise based getUserMedia(), see https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia */

      let that = this;
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          console.log(
            "getUserMedia() success, stream created, initializing Recorder.js ..."
          );
          /* assign to gumStream for later use */
          gumStream = stream;
          /* use the stream */
          input = audioContext.createMediaStreamSource(stream);
          /* Create the Recorder object and configure to record mono sound (1 channel) Recording 2 channels will double the file size */
          rec = new Recorder(input, {
            numChannels: 1,
          });
          //start the recording process
          rec.record();
          console.log("Recording started");
        })
        .catch(function (err) {
          //enable the record button if getUserMedia() fails
          console.log("Recording error: " + err);
          that.recordMode = "stopped";
        });
    },
    onPauseRecording() {
      // console.log("pauseButton clicked rec.recording=", rec.recording);
      // if (rec.recording) {
      //   //pause
      //   rec.stop();
      //   pauseButton.innerHTML = "Resume";
      // } else {
      //   //resume
      //   rec.record();
      //   pauseButton.innerHTML = "Pause";
      // }
    },
    onStopRecording() {
      console.log("stopButton clicked");
      //disable the stop button, enable the record too allow for new recordings
      this.recordMode = "stopped";
      //tell the recorder to stop the recording
      rec.stop(); //stop microphone access
      gumStream.getAudioTracks()[0].stop();
      //create the wav blob and pass it on to createDownloadLink
      rec.exportWAV(this.onRecordReady);
    },
    onRecordReady(blob) {
      this.recordUrl = URL.createObjectURL(blob);
      // var au = document.createElement('audio');
      // var li = document.createElement('li');
      // var link = document.createElement('a');
      // //add controls to the <audio> element
      // au.controls = true;
      // au.src = url;
      // //link the a element to the blob
      // link.href = url;
      // link.download = new Date().toISOString() + '.wav';
      // link.innerHTML = link.download;
      // //add the new audio and a elements to the li element
      // li.appendChild(au);
      // li.appendChild(link);
      // //add the li element to the ordered list
      // recordingsList.appendChild(li);
    },
    onPlayRecord() {
      console.log("play record");
      this.$refs.player.play();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.droopy {
  flex: 1;
  display: flex;
  min-height: 0;
  padding: 2rem 2rem 0 2rem;
}

.game-overlay {
  z-index: 1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);

  .pretty-button {
    position: fixed;
    top: 50%;
    margin-top: -2rem;
    height: 4rem;
    line-height: 4rem;

    &:hover {
      box-shadow: 0 3px 3px #0000005e;
    }
  }
}

.record-actions {
  margin-left: 1rem;
}
.record-action {
  font-family: "Material Icons";
  border: none;
  background-color: transparent;
  font-size: 2rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;

  &::after {
    color: white;
  }

  &[disabled="disabled"] {
    &::after {
      color: #777;
    }
  }
}
.record-start::after {
  content: "\e029";
}
.record-pause::after {
  content: "\e034";
}
.record-stop::after {
  content: "\e047";
}
.record-play::after {
  content: "\e037";
}

.sidebar {
  flex: 0 0 16rem;
  min-height: 0;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  margin-bottom: 2rem;
}

.sidebar ul.categories {
  list-style-type: none;
  padding: 0;
  overflow: auto;
}

.sidebar ul.categories li {
  display: block;
  text-align: right;
  margin-top: 0.65rem;
  margin-bottom: 0.65rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 90%;
}

.li-category-top + .li-category:before {
  content: "";
  display: block;
  border-top: 1px solid #ccc;
  padding-top: 0.6rem;
  margin-right: 0.5rem;
}

/*ul {
  list-style-type: none;
  padding: 0;
}*/
/*li {
  display: inline-block;
  margin: 0 10px;
}*/
.sidebar ul.categories li.selected {
  font-weight: bold;
  .category {
    color: #ccc;
  }
}
.category {
  cursor: default;
  color: #777;

  &::before {
    content: "[ ";
  }
  &::after {
    content: " ]";
  }

  &::before,
  &::after {
    visibility: hidden;
    font-weight: bold;
  }

  &:hover {
    color: #ccc;
    &::before,
    &::after {
      visibility: visible;
    }
  }
}

.content {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 2rem;

  .game {
    font-size: 150%;
    flex: 1;
    position: relative;
  }
}

h3 {
  margin: 40px 0 0;
}

.content-header {
  display: flex;
  margin-bottom: 2rem;
  flex: 0;
}
.content-header-group {
  flex: 1;
  display: flex;
  align-items: center;
}

.pretty-button {
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  font-size: 1rem;
  border-radius: 0.25rem;
  outline: none;
  margin-left: auto;
  margin-right: auto;
  height: 38px;
  padding: 0 1.5rem;
  font-weight: bold;
  line-height: 38px;
  box-shadow: 0 0px 0px #00000000;
  border-color: #2171b5;
  background-color: #2171b5;
  color: #fff;
  transition: all 300ms ease-in-out;

  text-transform: capitalize;

  &:hover {
    box-shadow: 0 2px 2px #0000005e;
  }
}

.icon-close {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  background-color: #999;
  text-align: center;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;

  &::before {
    content: "\2715";
  }
}

.search-input {
  margin-left: auto;
  position: relative;

  input {
    font-size: 1rem;
    padding: 0.25rem 32px 0.25rem 0.5rem;
    border: 2px solid transparent;
    outline: none;
    border-radius: 4px;

    &:focus {
      // outline: 2px solid #27334f;
      // outline-offset: -2px;
      border: 2px solid #27334f;
    }

    /* Chrome/Opera/Safari */
    &::-webkit-input-placeholder,
    /* Firefox 19+ */
    &::-moz-placeholder,
    /* IE 10+ */
    &:-ms-input-placeholder,
    /* Firefox 18- */
    &:-moz-placeholder {
      color: #ccc;
    }
  }

  .icon-close {
    right: 5px;
    top: 50%;
    margin-top: -10px;
  }
}
.search-result {
  position: absolute;
  top: 4rem;
  bottom: 2rem;
  right: 0;
  width: 30%;
  text-align: right;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0.5rem 1rem;
  border-radius: 12px;

  ul {
    overflow: auto;
    position: absolute;
    top: 0.5rem;
    bottom: 0.5rem;
    left: 0.5rem;
    right: 0.5rem;
    color: #777;

    li {
      list-style: none;
      padding-right: 1rem;
      margin-top: 0.65rem;
      margin-bottom: 0.65rem;
      line-height: 90%;

      .search-src::after {
        content: " \279e\00a0";
      }
    }
  }

  .icon-close {
    left: 10px;
    top: 10px;
  }
}

.droopy .game-status {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: -40px;
  left: 50%;
  margin-left: -40px;
  border-radius: 40px;
}
.droopy-ok .game-status {
  background-color: green;
}
.droopy-error .game-status {
  background-color: red;
}

.vue-friendly-iframe {
  position: absolute;
  top: 2rem;
  right: 2rem;
  bottom: 2rem;
  left: 2rem;
}

.close-frame {
  right: 22px;
  top: 22px;
}

.droopy-timer {
  /*position: absolute;
  width: 8rem;
  bottom: 0;
  left: 50%;
  margin-left: -4rem;*/
  display: none;
}
.droopy-gauge {
  position: absolute;
  bottom: -16px;
  left: 50%;
  margin-left: -180px; // 360 / 2
}

.timer-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background-color: #42b983;
}

@import "../scss/shared-radio-check.scss";
</style>
